/**
 * The CRM can return our answered-call notification email as an imported note.
 * Keep that note in the feed response for sync and storage; hide only its UI row.
 */
export function isReturnedAnsweredCallNote(item: { eventType: string; metadata?: unknown }): boolean {
  if (item.eventType?.toLowerCase() !== 'crm_note') return false;

  let metadata: unknown = item.metadata;
  if (typeof metadata === 'string') {
    try {
      metadata = JSON.parse(metadata);
    } catch {
      return false;
    }
  }
  if (!metadata || typeof metadata !== 'object' || Array.isArray(metadata)) return false;
  const body = (metadata as Record<string, unknown>).body;
  if (typeof body !== 'string') return false;

  // Require the updated answered_call.py HTML title, heading, intro, summary,
  // and contact CTA together. SendGrid can rewrite that CTA to its click URL.
  return /^\s*<!doctype html>\s*<html\b[\s\S]*<\/html>\s*$/i.test(body)
    && /<title>\s*Answered Call Notification\s*<\/title>/i.test(body)
    && /<h1\b[^>]*>\s*New Answered Call Notification\s*<\/h1>/i.test(body)
    && body.includes("A new call has been processed and analyzed by Speculo AI. Here's what we found:")
    && /<h2\b[^>]*>\s*Call Summary\s*<\/h2>/i.test(body)
    && /<a\b[^>]*href=["'](?:https:\/\/app\.speculo\.ai\/contact\/[^"']+|https:\/\/u[0-9]+\.ct\.sendgrid\.net\/ls\/click\?upn=[^"'&]+[^"']*)["'][^>]*>\s*View Contact Details\s*<\/a>/i.test(body);
}

export function filterReturnedAnsweredCallNotes<T extends { eventType: string; metadata?: unknown }>(items: T[]): T[] {
  return items.filter((item) => !isReturnedAnsweredCallNote(item));
}
